import { render } from "./AddCapture.vue?vue&type=template&id=3c07c6a8"
import script from "./AddCapture.vue?vue&type=script&lang=js"
export * from "./AddCapture.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__